/* eslint-disable */
import gsap from 'gsap';

export default function initTeamMemberMod() {
    document.querySelectorAll('.card.type-team_member').forEach(( card ) => {

        const bottom = card.querySelector('.bottom');
        const bottomContents = bottom.innerHTML;
        const bottomWrapper = document.createElement('div');
        bottomWrapper.classList.add('bottom-wrapper');
        bottomWrapper.innerHTML = bottomContents;
        bottom.innerHTML = '';
        bottom.appendChild(bottomWrapper);

        card.dataset.isOpened = 'false';
        card.dataset.collapseHeight = card.offsetHeight;

        const showMoreBtn = card.querySelector('button.show-more');
            if( showMoreBtn ) {
            showMoreBtn.addEventListener('click', (e) => {
                card.open();
            });
        }

        card.open = ( skip ) => {
            const body = card.querySelector('.body');
            const content = body.querySelector('.bottom');
            content.classList.toggle('is-open');
            showMoreBtn.classList.toggle('is-open');

            if (showMoreBtn.classList.contains('is-open')) {
                //gsap.to(content, { onStart: () => { card.style.minHeight = 'auto'; } ,  height: 'auto', duration: 0.3 } );
                if( skip ){
                    gsap.set(card, { height: '100%', maxHeight: '100%', onComplete: () => { card.style.height = 'auto'; } });
                    gsap.set(content, { height: 'auto' });
                } else {
                    gsap.to(card, { height: '100%', maxHeight: '100%', duration: 0.3, onComplete: () => { card.style.height = 'auto'; } });
                    gsap.to(content, { height: 'auto', duration: 0.3 });
                }
                card.dataset.isOpened = 'true';
            } else {
                //gsap.to(content, { onComplete: () => { card.style.minHeight = card.dataset.collapseHeight +'px'; } , height: 0 , duration: 0.3 });
                
                if( skip ){
                    gsap.set(card, { height: card.dataset.collapseHeight, maxHeight: card.dataset.collapseHeight });
                    gsap.set(content, { height: 0 });
                } else {
                    gsap.to(card, { height: card.dataset.collapseHeight, maxHeight: card.dataset.collapseHeight, duration: 0.3 });
                    gsap.to(content, { height: 0, duration: 0.3 });
                }
                card.dataset.isOpened = 'false';
            }
        }

        card.collapse = ( skip ) => {
            const body = card.querySelector('.body');
            const content = body.querySelector('.bottom');
            content.classList.remove('is-open');
            if ( showMoreBtn ) showMoreBtn.classList.remove('is-open');
            
            if( skip ) {
                gsap.set(card, { height: card.dataset.collapseHeight, maxHeight: card.dataset.collapseHeight });
                gsap.set(content, { height: 0 });
            } else {
                gsap.to(card, { height: card.dataset.collapseHeight , maxHeight: card.dataset.collapseHeight ,  duration: 0.0001 });
                gsap.to(content, { height: 0 , duration: 0.00001 });
            }
            card.dataset.isOpened = 'false';
        };

        card.dataset.isReady = 'true';
        const event = new Event('cardReady');
        setTimeout( ()=>{ card.dispatchEvent(event) } , 100 );
	});
}
